import { DEFAULT_ALT, NextImage, noForwardProps } from '@apeiron/temp'
import { Box, Container, styled, Tab, Tabs, Typography } from '@mui/material'
import { ROUTE } from '@src/constants/route'
import Link from 'next/link'
import * as R from 'ramda'
import * as RA from 'ramda-adjunct'
import { ChangeEvent, FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const TabsContainer = styled(Container)`
  background-color: #31343e;
  border-bottom: 2px solid #2b2e36;
  display: flex;
  justify-content: center;
`

export const StyledTabs = styled(Tabs)`
  justify-content: center;
  .MuiTab-root {
    margin-right: 20px;

    &:last-child {
      margin-right: 0;
    }
  }
  & .MuiTabs-indicator {
    background-color: #e4c169;
    height: 4px;
  }
`

const StyledTab = styled(Tab, noForwardProps)<TabProps>`
  margin-left: 24px;
  min-width: 130px;
  min-height: ${props => props.__height}px;
  opacity: 1;
`

const Icon = styled(Box)`
  aspect-ratio: 1;
  width: 36px;
`

const StyledNextImage = styled(NextImage)`
  height: 100%;
  width: 100%;
`

const Text = styled(Typography)`
  font-size: 20px;
  color: white;
  text-transform: none;
`

const SharedThirdNavBar: FC<Props> = (props: Props) => {
  const {
    className,
    index = 0,
    height = 56,
    navigationItems = [],
    onChange
  } = props

  const { t } = useTranslation()

  const handleOnChange = useCallback(
    (_: ChangeEvent<{}>, newIndex: number) => {
      if (onChange) {
        onChange(newIndex)
      }
    },
    [onChange]
  )

  return R.length(navigationItems) > 1 ? (
    <TabsContainer className={className}>
      <StyledTabs
        orientation={'horizontal'}
        value={index}
        variant='scrollable'
        onChange={handleOnChange}
      >
        {navigationItems.map((item: NavigationItem, index: number) => {
          const { icon, route, translationKey } = item

          return (
            <StyledTab
              LinkComponent={Link}
              key={route}
              __height={height}
              href={onChange ? '' : route}
              icon={
                RA.isNotNilOrEmpty(icon) ? (
                  <Icon>
                    <StyledNextImage alt={DEFAULT_ALT} src={icon} />
                  </Icon>
                ) : (
                  <></>
                )
              }
              iconPosition='start'
              label={<Text>{t(translationKey)}</Text>}
              value={index}
            />
          )
        })}
      </StyledTabs>
    </TabsContainer>
  ) : (
    <></>
  )
}

type Props = {
  className?: string
  index?: number
  height?: number
  navigationItems?: NavigationItem[]
  onChange?: (index: number) => void
}

type TabProps = { __height: number; href: string }

export type NavigationItem = {
  icon?: string
  route: ROUTE | string
  translationKey: string
}

export default SharedThirdNavBar
